import { DefaultButton, Dialog, DialogFooter, DialogType, Stack } from "@fluentui/react";
import { RootState } from "app/store";
import SafetyButton from "components/controls/SafetyButton";
import { EValidationSeverity } from "components/controls/ValidationView/ValidationView.type";
import PageLoading from "global/PageLoading";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { EValidationState, IValidationModel } from "./ValidationDialog.type";
import ValidationItem from "./ValidationItem";

interface IProps<T = IValidationModel> {
    onCancel: (e: T) => void;
    onContinue: (e: T) => void;
    defaultValue: T;
    loadingPageDuringValidation?: boolean;
    validate?: (e: T) => boolean;
}

const ValidationDialog = <T extends IValidationModel>(props: IProps<T>) => {

    const { onCancel } = props;

    const [viewModel, setViewModel] = useState<T | null>(null);

    const validating = viewModel?.state === EValidationState.Validating;

    const state = useSelector((state: RootState) => state);

    useEffect(() => {
        if (props.defaultValue && props.defaultValue.validationMessages)
            setViewModel(props.defaultValue);
        else
            setViewModel(null);

    }, [props.defaultValue, props.defaultValue?.state]);

    function onContinue(e: T) {
        props.onContinue(e);
    }

    if (!viewModel)
        return <></>;

    if (validating)
        if (props.loadingPageDuringValidation)
            return <PageLoading />;
        else
            return <></>

    let invalid = true;

    if (props.validate)
        invalid = !props.validate(viewModel);
    else
        invalid = viewModel && viewModel.validationMessages.some(q => q.type === EValidationSeverity.error);

    if (state.status.debug.admin)
        invalid = false;

    return <Dialog
        minWidth={'90vw'}
        hidden={false}
        // onDismiss={() => onCancel(viewModel)}
        dialogContentProps={{
            type: DialogType.largeHeader,
            title: 'Validation',
            subText: 'Please review item(s) below.\nClick each one to see more details',
        }}
        modalProps={{
            isBlocking: true,
            styles: {
                main: {
                    width: '90vw',
                    maxHeight: '95vh',
                },
            },
        }}
    >
        <Stack styles={{ root: { maxHeight: '60vh', overflowY: 'auto', overflowX: 'hidden', padding: '15px' } }}>
            {viewModel.validationMessages.map((vm, index) => {
                return <ValidationItem
                    key={index}
                    data={vm}
                    onChange={(change) => {
                        setViewModel(vm => {
                            return {
                                ...vm!,
                                validationMessages: vm!.validationMessages.map((eachVm, eachVMIndex) => {
                                    if (index === eachVMIndex)
                                        return { ...eachVm, ...change }

                                    return { ...eachVm }
                                })
                            }
                        });
                    }}
                />;
            })}
        </Stack>

        <DialogFooter styles={{ actions: { position: 'sticky', bottom: 0, background: 'white', paddingTop: 12, borderTop: '1px solid #edebe9' } }}>

            <SafetyButton
                text={"Continue"}
                onClick={() => onContinue(viewModel)}
                styles={{ root: { minWidth: '120px' } }}
                disabled={invalid}
            />

            <DefaultButton
                text={"Cancel"}
                onClick={() => onCancel(viewModel)}
                styles={{ root: { minWidth: '120px' } }}
            />

        </DialogFooter>

    </Dialog>;
}

export default ValidationDialog;